
    <div class="confirm-dialog" fxLayout="column" fxLayoutAlign="space-between">
      <div class="mat-title">
        {{ data.title | translate | sentancecase }}
      </div>

      <mat-form-field>
        <mat-label> {{ data.inputLabel | translate | sentancecase }}</mat-label>
        <input matInput [formControl]="inputControl" />
      </mat-form-field>

      <ml-dialog-actions
        [disable]="inputControl.invalid"
        (clickLeft)="onCancel()"
        (clickRight)="onSubmit()"
      ></ml-dialog-actions>
    </div>
  